import React, {Component} from 'react';
//import {Grid, Row, Col} from 'react-bootstrap';
import {
    Grid,
    Row, Col,
    Tabs, Tab,
} from 'react-bootstrap';

import Card from '../../components/Card/Card.jsx';
import AlertError from '../Components/AlertError.jsx';
import ContactService from "../../services/ContactService";
import FormInputs from '../../components/FormInputs/FormInputs.jsx';
import Button from "../../elements/CustomButton/CustomButton.jsx";


class View extends Component {
  constructor(props){
    super(props);
    this.state = {
        contact: [],
        alert: null,
        key: 1,
        currentId: this.props.match.params.action === 'create' ? 0 : this.props.match.params.number,
        fieldError: {},
        dataToSend: {},
    };
    this.getContact = this.getContact.bind(this);
    this.contactService = new ContactService();
    this.hideAlert = this.hideAlert.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
  }

  componentWillMount() {
    // Validaciones iniciales de campos requeridos en caso de create
    if (this.props.match.params.action ==='create') {
      const camposRequeridos = ['nombre', 'apellido'];
      const auxStateToSet = {};
      camposRequeridos.forEach((campo) =>{
        auxStateToSet[campo] = {};
        auxStateToSet[campo].error = true;
        auxStateToSet[campo].message = (
          <small className="text-danger">
            Campo requerido!
          </small>);
      });
      this.setState({ fieldError: auxStateToSet });
    }
  }

  componentDidMount() {
    this.getContact(this.state.currentId);
  }

  handleSelect(key){
    this.setState({key});
  }
  handleSubmit() {
    if (this.props.match.params.action ==='create') {
      this.contactService
        .createContact(this.state.dataToSend)
        .then(res => {
          this.props.history.push("/contacts");
          this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Contato creado satisfactoriamente!</div>), 10);
        })
        .catch(err => {
          console.log(err);
          this.errorAlert((<div>Ha ocurrido un error mientras se guardaban los cambios, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });
    } else {
      this.contactService
        .updateContact(this.state.currentId, this.state.dataToSend)
        .then(res => {
          this.props.history.push("/contacts");
          this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Contato guardado satisfactoriamente!</div>), 10);
        })
        .catch(err => {
          console.log(err);
          this.errorAlert((<div>Ha ocurrido un error mientras se guardaban los cambios, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });
    }

  }
  handleOnChange(event, name, tabName, type) {
    const auxStateArray = this.state.contact; // Guardar state en un array auxiliar para no mutarlo directamente
    const dataToSend = this.state.dataToSend;
    let textValue = '';
    switch (type) {
      case 'multiplechoice':
        const selectedOptions = Array.from(event.target.selectedOptions).map((option) => parseInt(option.value, 10)); // Get values of selected options into an array
        this.state.contact[tabName][name]['list'].forEach((item) => { // Encontrar textos para el valor seleccionado
          if (selectedOptions.includes(parseInt(item.value, 10))) {
            textValue += item.label+', '; // Armar string concatenando los valores seleccionados separados por ', '
          }
        });
        textValue = textValue.slice(0, -2); // Remover ', ' al final de la string
        auxStateArray[tabName][name].value = textValue;
        auxStateArray[tabName][name].selected = selectedOptions;
        dataToSend[name] = selectedOptions;
        this.setState({ contact: auxStateArray, dataToSend }); // Asignar nuevos valores con setState
        break;
      case 'select':
        const selectedValue = Array.from(event.target.selectedOptions)[0].value; // Index 0 porque nunca hay mas de uno
        this.state.contact[tabName][name]['list'].forEach((item) => { // Encontrar texto para el valor seleccionado
          if (parseInt(item.value, 10) === selectedValue) {
            textValue = item.label;
          }
        });
        auxStateArray[tabName][name].value = textValue;
        auxStateArray[tabName][name].selected = selectedValue;
        const nameToSend = name + 'id'; // Los nombres de los select en la DB las columnas tienen 'id' al final
        dataToSend[nameToSend] = selectedValue;
        this.setState({ contact: auxStateArray, dataToSend });
        break;
      default:
        // Inputs normales
        this.validateInput(type, event.target.value, name);
        dataToSend[name] = event.target.value;
        auxStateArray[tabName][name].value = event.target.value;
        this.setState({ contact: auxStateArray, dataToSend });
    }
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }
  getContact(id) {
    this.contactService
      .getContact(id)
      .then(res => {
        this.setState({ contact: res.contacts });
        //this.drawTabs(res.contacts);
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información del contacto, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  drawTabs() {
    const contact = this.state.contact;
    const disabled = (this.props.match.params.action === 'edit' || this.props.match.params.action === 'create') ? false : true;
    let tabsContent;
    tabsContent= Object.keys(contact).map((name, index) => {
      return (
        <Tab eventKey={index+1} title={name} key={index}>
          {this.drawData(name, contact[name], 3, disabled)}
        </Tab>
      );
    });
    return tabsContent;
  }
  drawData(tabName, fields, chunks, disabled){
    const keys = Object.keys(fields).map((name) => {
      return [name];
    });
    return this.chunk(keys, chunks).map((ele, index) => {
      let properties = [];
      let colclass;
      let ncols = [];
      ele.forEach((name) => {
        let fieldType = fields[name].type;
        if ( fieldType !== 'image' && fieldType !== 'multiplechoice' && fieldType !== 'select') {
          properties.push({
            tabName : tabName,
            label : fields[name].caption,
            type : fields[name].type,
            name : name[0],
            bsClass : "form-control",
            placeholder : fields[name].value,
            defaultValue : fields[name].value ? fields[name].value : '' ,
            disabled : disabled,
            list : fields[name].list ? fields[name].list : null,
            onChange : this.handleOnChange,
            error: this.state.fieldError.hasOwnProperty(name[0]) && this.state.fieldError[name[0]],
          });
        }
        if(fieldType === 'multiplechoice' || fieldType === 'select'){
          properties.push({
            tabName : tabName,
            label : fields[name].caption,
            type : fieldType,
            multiple: fieldType === 'multiplechoice' ? true : false,
            name : name[0],
            bsClass : "form-control",
            defaultValue: fields[name].selected,
            disabled : disabled,
            options : fields[name].list ? fields[name].list : [],
            onChange : this.handleOnChange,
          })
        }
      });
      colclass = 'col-md-' + (12 / properties.length);

      for (let i = 0; i < properties.length; i++) {
        ncols.push(colclass);
      }
      return (<FormInputs
          key = {index}
          ncols = {ncols}
          properties = {properties}
      />)
    })
  }
  chunk (arr, len) {
    var chunks = [],
        i = 0,
        n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, i += len));
    }
    return chunks;
  }

  validateInput(type, value, name) {
    const auxFieldError = this.state.fieldError;
    auxFieldError[name] = {};
    switch (type) {
      case 'email':
        const regMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (regMail.test(value) || value === '') {
          auxFieldError[name].error = false;
          this.setState({ fieldError: auxFieldError });
        } else {
          auxFieldError[name].error = true;
          auxFieldError[name].message = (
            <small className="text-danger">
              Email incorrecto! Verifique que el formato sea <i>usuario@dominio.com</i>.
            </small>);
          this.setState({ fieldError: auxFieldError });
        }
        break;
      case 'telefono':
        const regNumber = /^\d+$/;
        if (regNumber.test(value) || value === '') {
          auxFieldError[name].error = false;
          this.setState({ fieldError: auxFieldError });
        } else {
          auxFieldError[name].error = true;
          auxFieldError[name].message = (
            <small className="text-danger">
              Valor incorrecto! Ingrese solo números.
            </small>);
          this.setState({ fieldError: auxFieldError });
        }
        break;
      case 'uri':
        const regUrl = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
        if (regUrl.test(value) || value === '') {
          auxFieldError[name].error = false;
          this.setState({ fieldError: auxFieldError });
        } else {
          auxFieldError[name].error = true;
          auxFieldError[name].message = (
            <small className="text-danger">
              URL incorrecta! Verifique que el formato sea correcto
            </small>);
          this.setState({ fieldError: auxFieldError });
        }
        break;
      default:
        auxFieldError[name].error = false;
        this.setState({ fieldError: auxFieldError });
    }
    if (name === 'nombre' || name === 'apellido') {
      if (value === '' || null || undefined) {
        auxFieldError[name].error = true;
        auxFieldError[name].message = (
          <small className="text-danger">
            Campo requerido!
          </small>);
        this.setState({ fieldError: auxFieldError })
      } else {
        auxFieldError[name].error = false;
        this.setState({ fieldError: auxFieldError });
      }
    }
  }

  checkErrors() {
    const aux = this.state.fieldError;
    let error = false;
    Object.keys(aux).forEach((key, index) => { // Iterar en el objecto buscando errores true.
      if (aux[key].error) {
        error = true;
      }
    });
    return error;
  }

  render() {
    if (this.state.contact.length === 0) {
      return <div className="main-content">
      </div>
    } else {

      const saveButton = () => {
        if (this.props.match.params.action === 'edit' || this.props.match.params.action === 'create') {
          const disabledButton = this.checkErrors(); // Deshabilitar boton de guardado si hay errores en los campos
          return (
            <div style={{ textAlign: "right" }} title={disabledButton ? 'Uno o mas campos contienen errores!' : null}>
              <Button
                bsStyle="info"
                fill={true}
                wd={true}
                onClick ={this.handleSubmit}
                disabled = {disabledButton}
              >
                Guardar cambios
              </Button>
            </div>
          )
        }
      };

      return (<div className="main-content">
        {this.state.alert}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <Card title="Detalles"
                content={
                  <form>
                  <Tabs
                    activeKey={this.state.key}
                    onSelect={this.handleSelect}
                    id="controlled-tab"
                  >
                    {this.drawTabs()}
                  </Tabs>
                  {saveButton()}
                  </form>
                }
            />
            </Col>
          </Row>
        </Grid>
      </div>);
    }
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/views/Contacts/View.jsx